import React, {useContext} from 'react';
import UserItem from './UserItem';
import Spinner from '../Layout/Spinner';
// import PropTypes from 'prop-types';
import GithubContext from '../../context/github/githubContext';

const Users = () => {
  const githubContext = useContext(GithubContext);

  const {loading, users} = githubContext;

  if(loading){
    return <Spinner />
  }else{
    return (
      <div style = {userStyle}>
        {/* Using Traditional Function */}
        {/* {this.props.users.map (function(user){
            return <UserItem key={user.id} user={user} />
          }
        
            
        )} */}
        {/* Using Arrow Function */}
        {users.map (user =>
          <UserItem key={user.id} user={user} />
          
        )}

      </div>
    );
  }
    
  

}

// Users.propTypes = {
//   users: PropTypes.array.isRequired,
//   loading: PropTypes.bool.isRequired,
// }

const userStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: '1rem',
    color: 'darkBlue'
}

export default Users
